import CourseRecommendations from "../common/CourseRecommendations/CourseRecommendations";

function AIRecommended() {
    const aiRecommendedCourses = [
        {
            id: 1,

            title: "IT SUPPORT AGENTIC AI PROJECT COURSE",

            description:
                "Build an automated IT ticketing system using multi-agent architecture, deep learning, and MLOps to classify, route, and resolve tickets with minimal human intervention.",

            linkTitle:
                "Learn AI with Real Projects",

            lessons: "10",

            duration: "11:00 hours",

            url: "/replace-it-help-desk-with-automated-ticketing-system-using-ai",
        },

        {
            id: 2,

            title: "LEARN ML WITH REAL PROJECTS",

            description:
                "Build real-world machine learning solutions from scratch. This hands-on course focuses on practical projects—from data preparation to deployment—so you gain job-ready skills and experience with real ML applications.",

            linkTitle:
                "Learn ML with Real Projects",

            lessons: "14",

            duration: "18:00 hours",

            url: "/contact",
        },

        {
            id: 3,

            title: "LEARN PYTHON PROGRAMMING",

            description:
                "Learn Python from the ground up—perfect for beginners and intermediates aiming for careers in software development, data science, artificial intelligence, or automation.",

            linkTitle:
                "Learn Python Programming",

            lessons: "20",

            duration: "24:00 hours",

            url: "/python-courses-pay-after-learn",
        },

        {
            id: 4,

            title: "LEARN MACHINE LEARNING ONLINE",

            description:
                "Learn to build smart, predictive models using supervised and unsupervised learning with tools like Scikit-learn and TensorFlow.",

            linkTitle:
                "LEARN MACHINE LEARNING ONLINE",

            lessons: "20",

            duration: "24:00 hours",

            url: "/machine-learning-courses-pay-after-learn",
        },

        {
            id: 5,

            title: "LEARN DATA SCIENCE COURSES ONLINE",

            description:
                "Unlock insights from data and turn them into action. This course covers the full data science pipeline using Python, Pandas, NumPy, and Matplotlib—teaching you how to collect, clean, analyze, visualize, and make predictions with real-world datasets.",

            linkTitle:
                "Learn DATA SCIENCE COURSES ONLINE",

            lessons: "20",

            duration: "24:00 hours",

            url: "/data-science-courses-pay-after-learn",
        },
    ];

    return (
        <CourseRecommendations
            courses={aiRecommendedCourses}
        />
    );
}

export default AIRecommended;